'use client'

/* eslint-disable arrow-body-style */
import React from 'react'
import { useRouter } from 'next/navigation'
import { getCookie } from 'cookies-next'
import AboutUs from '@public/images/acko.png'
import TopicsPanel from '@components/Ackodrive/TopicPanel'
import AckodriveBreadCrumb from '@components/Ackodrive/breadCrumb'
import Paginator from '@components/Ackodrive/Paginator'
import RecentItems from '@components/Ackodrive/ItemDetails/RecentItems'
import CallbackWidget from '@components/Ackodrive/CallbackWidget'
import RecentTopicPosts from '@components/Ackodrive/RecentTopicPosts'
import { extractCardHeroImageUrl, extractCardHeroDescription } from '@components/Ackodrive/ItemsListing/utils'
import {
  ItemsListingWrapper,
  Divider,
  RightContainer,
  RightStickyContainer,
  RecentItemsContainer,
  CallbackWidgetExplore,
  CategoryList,
} from '@components/Ackodrive/ItemsListing/styles'
import CategoryCard from './Category'
import { CategoryTitle, CategoryPostsWrapper, CategoryWrapper, ContentWrapper, LeftContainer } from './styles'

const ArticleListingByTopic = ({
  slug,
  selectedCategory,
  categories,
  recentPosts,
  categoryPosts,
  total,
  limit,
  page,
  isMobileDevice,
  itemId,
  itemType,
}) => {
  const refereshAccessToken: any = getCookie('ackodrive_tokens') || '{}'
  const isLoggedIn = !!Object.keys(JSON.parse(decodeURIComponent(refereshAccessToken))).length

  const router = useRouter()

  const breadcrumb = [
    {
      value: 'Home',
      url: '/',
    },
    {
      value: 'Articles',
      url: '/articles/',
    },
    {
      value: selectedCategory?.attributes?.topicName,
      url: null,
    },
  ]

  const rangeLimit = Math.ceil(total / limit)
  const handlePaginationChange = pageNumber => {
    const pageNo = pageNumber
    router.push(`/articles/${slug}/page/${pageNo}`, { scroll: true })
  }

  return (
    <ItemsListingWrapper>
      <AckodriveBreadCrumb breadCrumbObj={breadcrumb} />
      <CategoryWrapper>
        <ContentWrapper isMobile={isMobileDevice}>
          <div>
            <LeftContainer>
              <CategoryTitle>{selectedCategory?.attributes?.topicName}</CategoryTitle>
              <CategoryPostsWrapper>
                {categoryPosts.data.map((item, index) => {
                  return (
                    <CategoryCard
                      key={index}
                      image={
                        extractCardHeroImageUrl(item?.attributes?.contentBeforeToc) || {
                          url: AboutUs,
                          title: item.attributes.title || item.attributes.articleTitle,
                        }
                      }
                      title={item.attributes.title || item.attributes.articleTitle}
                      articleUrl={`${item.attributes.url}`}
                      modifiedDate={item.attributes.updatedAt}
                      description={extractCardHeroDescription(item?.attributes?.contentBeforeToc)}
                    />
                  )
                })}
              </CategoryPostsWrapper>
            </LeftContainer>

            {rangeLimit > 1 && (
              <Paginator
                isMobile={isMobileDevice}
                currentPage={page}
                rangeLimit={rangeLimit}
                handlePaginationChange={handlePaginationChange}
                pageUrl={`/articles/${slug}/`}
              />
            )}

            {!isLoggedIn && (
              <>
                <Divider />
                <RecentItems recentItems={recentPosts} itemId={itemId} itemType={itemType} />
                {categories?.length > 0 && <TopicsPanel data={categories} />}
              </>
            )}
          </div>
          <RightContainer>
            <RightStickyContainer isMobile={isMobileDevice}>
              <CallbackWidgetExplore>
                <CallbackWidget isMobile={isMobileDevice} />
              </CallbackWidgetExplore>
              <RecentItemsContainer isMobile={isMobileDevice}>
                <RecentTopicPosts posts={recentPosts} />
                <CategoryList>
                  <RecentTopicPosts title="Categories" posts={categories} />
                </CategoryList>
              </RecentItemsContainer>
            </RightStickyContainer>
          </RightContainer>
        </ContentWrapper>
      </CategoryWrapper>
      <AckodriveBreadCrumb breadCrumbObj={breadcrumb} />
    </ItemsListingWrapper>
  )
}

export default ArticleListingByTopic
